import {
  Asset,
  AssetType,
  hasVideoSources,
  PatientCaseContent,
  patientCaseContentSchema,
} from '@llx/common';
import { ZodError } from 'zod';

import { getAssetUrl } from '../createAssetUrl';
import { captureSentry } from './sentryHelper';

export const parseCaseAssets = (caseContent: PatientCaseContent): PatientCaseContent => {
  const caseAssetsMap: { [assetId: string]: Asset } = {};

  caseContent.assets.forEach((asset) => {
    asset.url = getAssetUrl(caseContent.path, asset.path);

    switch (asset.type) {
      case AssetType.IMAGE:
        asset.thumbUrl = asset.url;
        break;
      case AssetType.VIDEO:
        asset.thumbUrl = getAssetUrl(caseContent.path, asset.thumbPath);
        // If multi-quality sources exist, compute URL for each source as well
        if (hasVideoSources(asset)) {
          asset.sources = asset.sources.map((source) => ({
            ...source,
            url: getAssetUrl(caseContent.path, source.path),
          }));
        }
        break;
    }
    if (asset.thumbUrl.includes('mp4')) {
      console.warn(
        `WARN: (${caseContent.id}) Asset with "${asset.id}" has a thumb with .mp4 extension, please use .jpg`
      );
    }
    caseAssetsMap[asset.id] = { ...asset };
  });

  /*
  NOTE: validate if the case is well formatted
  */
  try {
    patientCaseContentSchema.parse(caseContent);
  } catch (err) {
    if (err instanceof ZodError) {
      captureSentry({
        title: 'PatientCase validation failed while fetching caseData',
        error: err,
        detail: {
          errorMessage: err.message,
          caseContent: caseContent,
        },
      });
      console.error(`PatientCase validation failed: ${caseContent.id} ${err.toString()}`);
    }
  }
  return caseContent;
};
